export const selectAllBoards = state => state.boards.info;
export const selectIsBoardsLoading = state => state.boards.isLoading;
